import { FC, ReactNode, useContext } from 'react';
import { Checkbox } from '@chakra-ui/checkbox';
import { ICON_BY_NAME } from '..';
import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';
import classnames from 'classnames';
import { TableContext } from './';
import { SortDirection } from 'hooks/useTable';
import { CbTooltip } from '..';
import styles from './TableHead.module.css';
export const TableHead: FC = () => {
  const {
    allVisibleRowsSelected,
    hasBulkSelect,
    headerInfo,
    tableName,
    toggleSelectAllVisibleRows
  } = useContext(TableContext);
  return <thead data-sentry-component="TableHead" data-sentry-source-file="TableHead.tsx">
      <tr>
        {!!hasBulkSelect && <th className={styles.headerCell}>
            <div className={styles.headerCellSelectAll}>
              <Checkbox isChecked={allVisibleRowsSelected()} onChange={toggleSelectAllVisibleRows} />
            </div>
          </th>}
        {headerInfo.map(col => <TableHeadCell {...col} key={`${tableName}-header-cell-${col.id}`} />)}
      </tr>
    </thead>;
};
const TableHeadCell: FC<TableHeadCellProps> = ({
  disableSort,
  id,
  name,
  renderTooltipContent,
  sortDirection
}) => {
  const {
    handleColumnSort
  } = useContext(TableContext);
  const onHeaderClick = () => disableSort ? null : handleColumnSort(id);
  const icon = disableSort ? null : <div className={styles.iconContainer}>
      <TriangleUpIcon boxSize="0.6rem" className={classnames(styles.sortIcon, {
      [styles.inactive]: sortDirection !== SortDirection.Asc
    })} />
      <TriangleDownIcon boxSize="0.6rem" className={classnames(styles.sortIcon, {
      [styles.inactive]: sortDirection !== SortDirection.Desc
    })} />
    </div>;
  const tooltip = () => {
    if (!renderTooltipContent) return null;
    return <CbTooltip backgroundColor="#f3eef9" isLazy placement={'bottom'} width="400px" content={renderTooltipContent()} data-sentry-element="CbTooltip" data-sentry-component="tooltip" data-sentry-source-file="TableHead.tsx">
        <ICON_BY_NAME.infocircle color="chonky.500" height="14px" marginLeft={2} id="locked_user_info_tooltip" data-sentry-element="unknown" data-sentry-source-file="TableHead.tsx" />
      </CbTooltip>;
  };
  return <th className={styles.headerCell} onClick={onHeaderClick} data-sentry-component="TableHeadCell" data-sentry-source-file="TableHead.tsx">
      <div className={styles.headerCellContent}>
        <span>{name}</span>
        <>{icon}</>
        <>{tooltip()}</>
      </div>
    </th>;
};
interface TableHeadCellProps {
  disableSort: boolean;
  id: string;
  name: string;
  renderTooltipContent?: () => ReactNode;
  sortDirection: SortDirection;
}